module.exports = __webpack_public_path__ + "img/biolargo.089e3cf5.png";